function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 7;\n  transition: flex 250ms linear;\n  align-self: start;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  transition: flex 250ms linear;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import React, { PureComponent } from "react";
import propTypes from "prop-types";
import { FiChevronsRight } from "react-icons/fi";
import { IoMdArrowBack } from "react-icons/io";
import memoizeOne from "memoize-one";
import keyBy from "lodash/keyBy";
import { Grid, Row, SpacedCol } from "../../grid";
import { withContext, context } from "../../wr-context";
import { Formik } from "formik";
import connectRequest from "../../../utils/connect-request";
import { generateTransaction } from "../../../utils/transactions";
import ProductCard from "./product-card";
import { PromiseState } from "react-refetch";
import { MediumText, CenteredText, MutedText, EngravedText } from "../../text";
import { requests, utils } from "../../../modules/product";
import { requests as bundleRequests } from "../../../modules/bundles";
import shallowEqual from "../../../utils/shallow-equal";
import { getCartId } from "../../../utils/product/getCartId";
import Progress from "../../progress";
import Link from "../../link";
import styled from "styled-components";
import Cart from "./components/cart";
import i18n from "../../../utils/i18n";
import Feedback from "./feedback";
import BackButton from "../../back-button";
var ProductDescription = styled.div(_templateObject());
var CustomCol = styled(function(_param) /*#__PURE__*/ {
    var sticky = _param.sticky, rest = _objectWithoutProperties(_param, [
        "sticky"
    ]);
    return React.createElement(SpacedCol, _extends({}, rest));
})(_templateObject1(), function(param) {
    var sticky = param.sticky;
    return sticky && "\n    position: sticky;\n    top: 0;\n  ";
});
var BackButtonStyled = styled.div(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.components.productDetails.backButton;
});
var getRows = function(props) {
    var product = props.productFetch.value;
    var rows = product && product.rows ? product.rows : [];
    return rows;
};
var isValid = function(schema, values) {
    try {
        schema.validateSync(values);
        return true;
    } catch (e) {
        return false;
    }
};
var ProductDetail = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ProductDetail, PureComponent);
    var _super = _createSuper(ProductDetail);
    function ProductDetail() {
        _classCallCheck(this, ProductDetail);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            skipRange: {},
            formikValues: null
        };
        // Used to regenerate cartId after each successful submission
        _this.submitCount = 0;
        _this.transactionLogged = false;
        _this.handleSubmit = function(values, formikBag) {
            if (_this.props.onSubmit) {
                _this.props.onSubmit(utils.mergeRowsValues(values, _this.props.productFetch.value), _objectSpreadProps(_objectSpread({}, formikBag), {
                    values: values
                }));
            } else {
                formikBag.setSubmitting(false);
            }
        };
        _this.blockEnterSubmission = function(e) {
            if ((e === null || e === void 0 ? void 0 : e.key) === "Enter") {
                e.preventDefault();
            }
        };
        _this.getInitialValues = memoizeOne(function(rows) {
            var prefillValuesByRowLabel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _this.props.prefillValuesByRowLabel;
            var prefillValues = {};
            if (prefillValuesByRowLabel) {
                prefillValues = Object.entries(prefillValuesByRowLabel).map(function(param) {
                    var _param = _slicedToArray(param, 2), k = _param[0], v = _param[1];
                    var row = rows.find(function(v) {
                        return v.label.toLowerCase() === k.toLowerCase();
                    });
                    if (!row) {
                        return {};
                    }
                    return _defineProperty({}, row.id, v);
                }).reduce(function(a, b) {
                    return _objectSpread({}, a, b);
                }, {});
            }
            var computedInitialValues = _objectSpread({}, utils.getProductFormikInitialValues(rows), prefillValues, _this.props.initialValues);
            return computedInitialValues;
        });
        _this.getCartId = memoizeOne(function(_) {
            return getCartId();
        });
        _this.getProduct = function() {
            var _props = _this.props, bundleId = _props.bundleId, bundlesFetch = _props.bundlesFetch, pointSystem = _props.pointSystem, productFetch = _props.productFetch;
            var formikValues = _this.state.formikValues || _this.getInitialValues(getRows(_this.props));
            var product;
            if (bundleId) {
                var fetchedBundle = bundlesFetch === null || bundlesFetch === void 0 ? void 0 : bundlesFetch.value.find(function(b) {
                    return b.id === bundleId;
                });
                var id = fetchedBundle.id, name = fetchedBundle.name, settings = fetchedBundle.settings, description = fetchedBundle.description;
                var fetchData = _this.getBundlesFetch(_this.props);
                var products = fetchData ? fetchData.products : null;
                var bundleItems = [];
                if (products) {
                    products.forEach(function(prod) {
                        bundleItems.push({
                            name: prod.value.name,
                            description: prod.value.description
                        });
                    });
                }
                product = _objectSpreadProps(_objectSpread({}, fetchedBundle), {
                    id: id,
                    cartId: _this.getCartId(_this.submitCount),
                    name: name,
                    price: pointSystem ? settings.displayText : settings.cost,
                    priceLabel: settings.serviceRateLabel,
                    description: description,
                    type: "bundle",
                    bundleItems: bundleItems,
                    values: formikValues
                });
            } else {
                var fetchedProduct = productFetch.value;
                var id1 = fetchedProduct.id, name1 = fetchedProduct.name, serviceRateLabel = fetchedProduct.serviceRateLabel, description1 = fetchedProduct.description;
                product = _objectSpreadProps(_objectSpread({}, fetchedProduct), {
                    id: id1,
                    cartId: _this.getCartId(_this.submitCount),
                    name: name1,
                    price: utils.getPrice(fetchedProduct),
                    priceLabel: serviceRateLabel,
                    description: description1,
                    type: "product",
                    rows: utils.mergeRowsValues(formikValues, _objectSpread({}, fetchedProduct)).rows,
                    values: formikValues
                });
                var mergedRowsById = keyBy(product.rows, "id");
                product.rows = fetchedProduct.rows.map(function(row) {
                    return mergedRowsById[row.id] || row;
                });
                product.price = utils.getPrice(product);
            }
            return product;
        };
        _this.handleChange = function(prevFormik, formik) {
            var prevValues = prevFormik.values;
            var values = formik.values;
            var updateCartProductValues = context.actions.updateCartProductValues, cart = context.state.cart, utils = context.utils;
            var productCartIdParam = _this.props.productCartIdParam;
            var product = _this.getProduct();
            var productId = product.id;
            if (productCartIdParam) {
                if (formik && formik.values.cartId !== productCartIdParam) {
                    formik.setFieldValue("cartId", productCartIdParam);
                }
            }
            if (productCartIdParam) {
                if (!shallowEqual(values, prevValues) && prevValues.cartId === values.cartId && (cart === null || cart === void 0 ? void 0 : cart.find(function(el) {
                    return el.id + el.cartId === productId + productCartIdParam;
                }))) {
                    updateCartProductValues(productId, productCartIdParam, values);
                }
            } else {
                if (!utils.products.allowsMultipleSameProductsInCart(product) && !shallowEqual(values, prevValues) && (cart === null || cart === void 0 ? void 0 : cart.find(function(el) {
                    return el.id === productId;
                }))) {
                    updateCartProductValues(productId, false, values);
                }
            }
            if (_this.props.onChange) {
                if (shallowEqual(values, prevValues)) {
                // States are equal, no change has occurred
                } else {
                    _this.props.onChange(values, _this.props.productFetch.value, prevFormik, formik, product);
                }
            }
            _this.setState({
                formikValues: values,
                skipRange: values.skipRange
            });
        };
        _this.toggleProduct = function() {
            var ref;
            var _actions = context.actions, addProductToCart = _actions.addProductToCart, removeProductFromCart = _actions.removeProductFromCart;
            var product = _this.getProduct();
            var multiple = context.utils.products.allowsMultipleSameProductsInCart(product);
            var addedToCart = !multiple && ((ref = _this.props.cart) === null || ref === void 0 ? void 0 : ref.some(function(v) {
                return v.id === product.id;
            }));
            if (addedToCart) {
                removeProductFromCart(product.id, product);
                _this.props.onCartRemove && _this.props.onCartRemove(product);
                _this.submitCount = 0;
            } else {
                addProductToCart(product);
                _this.props.onCartAdd && _this.props.onCartAdd(product);
                _this.submitCount += 1;
            }
        };
        _this.renderForm = function(formik) {
            var ref;
            var _props = _this.props, bundleId = _props.bundleId, productFetch = _props.productFetch, showPrice = _props.showPrice, renderPrice = _props.renderPrice, showDescription = _props.showDescription, showAddToOrder = _props.showAddToOrder, addButtonLabel = _props.addButtonLabel, addAnotherButtonLabel = _props.addAnotherButtonLabel, addedButtonLabel = _props.addedButtonLabel, enableValidation = _props.enableValidation, viewQuoteButtonLabel = _props.viewQuoteButtonLabel, zDepth = _props.zDepth, overrides = _props.overrides, showHeader = _props.showHeader, pointSystem = _props.pointSystem, showHeaderRows = _props.showHeaderRows, hidePriceAndDurationIfZero = _props.hidePriceAndDurationIfZero, headerRowsColors = _props.headerRowsColors, replaceTab = _props.replaceTab, AddToSOW = _props.AddToSOW, disabled = _props.disabled, getRow = _props.getRow, showResetButton = _props.showResetButton, onReset = _props.onReset, hideQuoteButton = _props.hideQuoteButton, cart = _props.cart, shouldResetOnAdd = _props.shouldResetOnAdd;
            var product = _this.getProduct();
            var fetchData = bundleId ? _this.getBundlesFetch(_this.props) : null;
            var products = fetchData ? fetchData.products : null;
            var flipKey = Object.values(formik.values).join("");
            var price = product ? utils.getPrice(product) : 0;
            var multiple = context.utils.products.allowsMultipleSameProductsInCart(product);
            var addedToCart = !multiple && _this.props.cart && ((ref = _this.props.cart) === null || ref === void 0 ? void 0 : ref.some(function(v) {
                return v.id === product.id;
            }));
            var isBundle = product.groupType === "bundle";
            if (isBundle) {
                price = pointSystem ? product.pricing.value : product.settings.cost;
            }
            var cardProps = {
                products: products,
                productFetch: productFetch,
                showPrice: showPrice,
                renderPrice: renderPrice,
                showDescription: showDescription,
                showAddToOrder: showAddToOrder,
                addButtonLabel: addButtonLabel,
                addAnotherButtonLabel: addAnotherButtonLabel,
                addedButtonLabel: addedButtonLabel,
                enableValidation: enableValidation,
                viewQuoteButtonLabel: viewQuoteButtonLabel,
                product: product,
                flipKey: flipKey,
                price: price,
                canAddToCart: !addedToCart,
                formik: formik,
                zDepth: zDepth,
                overrides: overrides,
                hidePriceAndDurationIfZero: hidePriceAndDurationIfZero,
                blockEnterSubmission: _this.blockEnterSubmission,
                handleChange: _this.handleChange,
                toggleProduct: _this.toggleProduct,
                showHeader: showHeader,
                headerRowsColors: headerRowsColors,
                AddToSOW: AddToSOW,
                replaceTab: replaceTab,
                showHeaderRows: showHeaderRows,
                disabled: disabled,
                skipRange: _this.state.skipRange,
                validateCart: _this.props.validateCart,
                addToCartSubmits: _this.props.addToCartSubmits,
                addToCartAlways: _this.props.addToCartAlways,
                stepped: _this.props.stepped,
                stepperProps: _this.props.stepperProps,
                getRow: getRow,
                showResetButton: showResetButton,
                onReset: onReset,
                hideQuoteButton: hideQuoteButton,
                getInitialValues: _this.getInitialValues,
                detailStartOverConfig: _this.props.detailStartOverConfig,
                cart: cart,
                shouldResetOnAdd: shouldResetOnAdd
            };
            return /*#__PURE__*/ React.createElement(ProductCard, _extends({}, cardProps));
        };
        _this.getBundlesFetch = function(props) {
            var products = props.productFetch.value && props.productFetch.value.data.map(function(_, index) {
                return "productFetch".concat(index);
            }).map(function(id) {
                if (props[id]) {
                    return props[id];
                }
                return false;
            });
            var productFetch = {
                pending: true,
                fulfilled: false
            };
            if (Array.isArray(products)) {
                productFetch = PromiseState.all([
                    props.productFetch,
                    props.bundlesFetch
                ].concat(_toConsumableArray(products)));
            }
            return {
                productFetch: productFetch,
                products: products
            };
        };
        return _this;
    }
    var _proto = ProductDetail.prototype;
    _proto.logTransaction = function logTransaction(product) {
        if (this.transactionLogged) return;
        var transaction = {
            action: "viewed",
            type: "product",
            id: product.id,
            hname: product.name
        };
        generateTransaction(transaction);
        this.transactionLogged = true;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var ref;
        var _props = this.props, productFetch = _props.productFetch, onChange = _props.onChange, productId = _props.productId, bundleId = _props.bundleId;
        var previousBundleFetchData = bundleId ? this.getBundlesFetch(prevProps).productFetch : null;
        var currentBundleFetchData = bundleId ? this.getBundlesFetch(this.props) : null;
        // Dispatch change when product is first received
        if (productId && onChange && !((ref = prevProps.productFetch) === null || ref === void 0 ? void 0 : ref.fulfilled) && productFetch.fulfilled) {
            var product = productFetch.value;
            var initialValues = this.getInitialValues(product.rows);
            this.setState({
                skipRange: initialValues.skipRange
            });
            onChange(initialValues, product);
        }
        if (bundleId && onChange && !(previousBundleFetchData === null || previousBundleFetchData === void 0 ? void 0 : previousBundleFetchData.fulfilled) && (currentBundleFetchData === null || currentBundleFetchData === void 0 ? void 0 : currentBundleFetchData.productFetch.fulfilled)) {
            var product1 = productFetch.value.data;
            var rows = [];
            currentBundleFetchData === null || currentBundleFetchData === void 0 ? void 0 : currentBundleFetchData.products.forEach(function(product) {
                var _rows;
                (_rows = rows).push.apply(_rows, _toConsumableArray(product.value.rows));
            });
            var initialValues1 = this.getInitialValues(rows);
            onChange(initialValues1, product1);
        }
    };
    _proto.render = function render() {
        var _props, ref;
        var _props1 = this.props, productId = _props1.productId, bundleId = _props1.bundleId, showBackButton = _props1.showBackButton, backButtonCb = _props1.backButtonCb, cart = _props1.cart, asPdf = _props1.asPdf, asDoc = _props1.asDoc, onSubmit = _props1.onSubmit, showVMSButton = _props1.showVMSButton, enableValidation = _props1.enableValidation, OverrideCart = _props1.Cart, getProduct = _props1.getProduct, prefillValuesByRowLabel = _props1.prefillValuesByRowLabel, validationSchema = _props1.validationSchema, renderPrice = _props1.renderPrice, enableCart = _props1.enableCart, showCartAlways = _props1.showCartAlways;
        var productFetch = {
            pending: true
        };
        var products = [];
        var CartComponent = OverrideCart || Cart;
        if (productId) {
            productFetch = this.props.productFetch;
        } else {
            var fetchData = this.getBundlesFetch(this.props);
            products = fetchData.products;
            productFetch = fetchData.productFetch;
        }
        if (productFetch.pending) {
            return /*#__PURE__*/ React.createElement(Progress, {
                "data-testid": "product-detail-progress"
            });
        } else if (productFetch.rejected) {
            return /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(MediumText, null, /*#__PURE__*/ React.createElement(CenteredText, null, /*#__PURE__*/ React.createElement(EngravedText, null, /*#__PURE__*/ React.createElement(MutedText, {
                "data-testid": "product-detail-error"
            }, i18n("productDetails.loadingError"))))));
        }
        var product = this.getProduct();
        var rows = product && product.rows ? product.rows : [];
        if (getProduct) {
            getProduct(product);
        }
        if (bundleId && products) {
            products.forEach(function(product) {
                if (product.value && product.value.rows) {
                    var _rows;
                    (_rows = rows).push.apply(_rows, _toConsumableArray(product.value.rows));
                }
            });
        }
        var showCart = enableCart && (showCartAlways || ((cart === null || cart === void 0 ? void 0 : cart.length) || 0) > 0);
        var initialValues = this.getInitialValues(rows, prefillValuesByRowLabel);
        if (product) {
            this.logTransaction(product);
        }
        var finalValidationSchema = validationSchema || utils.getProductValidationSchema(product.rows, this.state.skipRange);
        var renderedParts = {
            feedback: /*#__PURE__*/ React.createElement(Feedback, {
                product: product
            }),
            backButton: showBackButton && /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(SpacedCol, {
                xs: 12
            }, /*#__PURE__*/ React.createElement(BackButtonStyled, {
                "data-testid": "product-detail-back-button"
            }, backButtonCb ? /*#__PURE__*/ React.createElement(BackButton, {
                onClick: backButtonCb
            }, /*#__PURE__*/ React.createElement(IoMdArrowBack, null), "Back") : /*#__PURE__*/ React.createElement(Link, {
                to: context.getRoutePath("index")
            }, /*#__PURE__*/ React.createElement(IoMdArrowBack, null), "Back")))),
            mainSection: product && /*#__PURE__*/ React.createElement(Formik, _extends({
                enableReinitialize: true,
                onSubmit: this.handleSubmit,
                initialValues: initialValues,
                render: this.renderForm
            }, enableValidation && finalValidationSchema ? {
                validationSchema: finalValidationSchema,
                isInitialValid: isValid(finalValidationSchema, initialValues)
            } : {})),
            cartSection: showCart && /*#__PURE__*/ React.createElement(CartComponent, {
                asPdf: Boolean(asPdf),
                asDoc: asDoc,
                submitProposal: onSubmit || function() {},
                showVMSButton: Boolean(showVMSButton),
                renderPrice: renderPrice,
                hidePriceAndDurationIfZero: true
            }),
            renderFullMainSection: function(param) {
                var mainSection = param.mainSection, cartSection = param.cartSection;
                var ref;
                return product && /*#__PURE__*/ React.createElement(Row, {
                    top: "xs"
                }, /*#__PURE__*/ React.createElement(CustomCol, {
                    xs: 12,
                    sm: showCart ? 9 : 12
                }, /*#__PURE__*/ React.createElement(ProductDescription, null, mainSection)), showCart && /*#__PURE__*/ React.createElement(CustomCol, {
                    xs: 12,
                    sm: 3,
                    sticky: (ref = context.theme.components.productDetails.cart) === null || ref === void 0 ? void 0 : ref.sticky
                }, cartSection));
            },
            noProducts: !product && /*#__PURE__*/ React.createElement(Row, {
                center: "xs"
            }, /*#__PURE__*/ React.createElement(SpacedCol, {
                xs: 12
            }, /*#__PURE__*/ React.createElement(CenteredText, null, /*#__PURE__*/ React.createElement(EngravedText, null, /*#__PURE__*/ React.createElement(MediumText, null, /*#__PURE__*/ React.createElement(MutedText, null, i18n("product.noProductError")))))))
        };
        return (ref = (_props = this.props).children) === null || ref === void 0 ? void 0 : ref.call(_props, renderedParts, {
            props: this.props,
            product: product,
            initialValues: initialValues
        });
    };
    return ProductDetail;
}(PureComponent);
ProductDetail.propTypes = {
    productId: propTypes.string,
    bundleId: propTypes.string,
    productCartIdParam: propTypes.string,
    showPrice: propTypes.oneOfType([
        propTypes.bool,
        propTypes.func
    ]),
    renderPrice: propTypes.func,
    showBackButton: propTypes.bool,
    backButtonCb: propTypes.func,
    showDescription: propTypes.bool,
    onChange: propTypes.func,
    showAddToOrder: propTypes.bool,
    enableValidation: propTypes.bool,
    overrides: propTypes.object,
    headerRowsColors: propTypes.array,
    showHeaderRows: propTypes.bool,
    addButtonLabel: propTypes.oneOfType([
        propTypes.string,
        propTypes.node
    ]),
    addAnotherButtonLabel: propTypes.oneOfType([
        propTypes.string,
        propTypes.node
    ]),
    addedButtonLabel: propTypes.string,
    viewQuoteButtonLabel: propTypes.any,
    initialValues: propTypes.object,
    showHeader: propTypes.bool,
    disabled: propTypes.bool,
    enableCart: propTypes.bool,
    children: propTypes.any,
    validateCart: propTypes.bool,
    addToCartSubmits: propTypes.bool,
    addToCartAlways: propTypes.bool,
    stepped: propTypes.bool,
    stepperProps: propTypes.object,
    onSubmit: propTypes.func,
    productFetch: propTypes.object,
    pointSystem: propTypes.bool,
    bundlesFetch: propTypes.object,
    cart: propTypes.array,
    zDepth: propTypes.number,
    Cart: propTypes.any,
    AddToSOW: propTypes.elementType,
    replaceTab: propTypes.object,
    hidePriceAndDurationIfZero: propTypes.bool,
    asPdf: propTypes.bool,
    asDoc: propTypes.bool,
    showVMSButton: propTypes.bool,
    getProduct: propTypes.func,
    prefillValuesByRowLabel: propTypes.object,
    validationSchema: propTypes.object,
    showCartAlways: propTypes.bool,
    onCartAdd: propTypes.func,
    onCartRemove: propTypes.func,
    showResetButton: propTypes.bool,
    onReset: propTypes.func,
    hideQuoteButton: propTypes.bool,
    detailStartOverConfig: propTypes.shape({
        replaceQuoteWithStartOver: propTypes.bool,
        onStartOverClick: propTypes.func,
        overrideBaseClick: propTypes.bool
    }),
    shouldResetOnAdd: propTypes.bool
};
ProductDetail.defaultProps = {
    productCartIdParam: undefined,
    showDescription: true,
    showHeaderRows: false,
    showAddToOrder: true,
    addButtonLabel: i18n("productDetails.addToOrder"),
    addAnotherButtonLabel: i18n("productDetails.addAnotherToOrder"),
    addedButtonLabel: i18n("productDetails.addedToOrder"),
    viewQuoteButtonLabel: /*#__PURE__*/ React.createElement(React.Fragment, null, i18n("productDetails.viewQuote"), " ", /*#__PURE__*/ React.createElement(FiChevronsRight, null)),
    initialValues: {},
    showHeader: true,
    headerRowsColors: [],
    renderPrice: function(x) {
        return x.defaultRender();
    },
    overrides: undefined,
    enableValidation: false,
    onChange: undefined,
    showBackButton: false,
    showPrice: false,
    bundleId: undefined,
    productId: undefined,
    disabled: false,
    addToCartAlways: false,
    enableCart: true,
    showResetButton: false,
    hideQuoteButton: false,
    children: function(renderedParts /* , options */ ) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, renderedParts.feedback, renderedParts.backButton, renderedParts.renderFullMainSection(renderedParts), renderedParts.noProducts);
    },
    validateCart: false,
    addToCartSubmits: false,
    shouldResetOnAdd: false
};
export default Object.assign(connectRequest(function(param) {
    var productId = param.productId, bundleId = param.bundleId;
    var queuedRequests = {};
    if (productId) {
        queuedRequests.productFetch = requests.fetchProductById(productId);
    } else if (bundleId) {
        queuedRequests.bundlesFetch = bundleRequests.fetchBundles({
            getAllBundles: true
        });
        queuedRequests.productFetch = bundleRequests.fetchBundleById(bundleId);
    }
    return _objectSpread({}, queuedRequests);
})(withContext(ProductDetail, {
    mapProps: function(context) {
        return {
            cart: context.state.cart,
            pointSystem: context.state.pointSystem
        };
    }
})), {
    Feedback: Feedback
});
